import request from '@/config/axios'

export interface LiveBlacklistVO {
  id?: number
  roomId?: number
  memberId?: number
}

export const pageBlacklist = (params: any) => request.get({ url: '/live/blacklist/page', params })
export const getBlacklist = (id: number) =>
  request.get({ url: '/live/blacklist/get', params: { id } })
export const deleteBlacklist = (id: number) =>
  request.delete({ url: '/live/blacklist/delete', params: { id } })
